// extracted by mini-css-extract-plugin
module.exports = {"perfomancePanel":"styles_perfomancePanel__uF5VG","field":"styles_field__UsH_f"};